/**
 * Seções visíveis do formulário de agente (ordem de exibição).
 * @returns {Array<{ id: string, labelKey: string, hintKey?: string, step: number }>}
 */
export function buildAgentFormSections({
  engineType,
  primarySkillKey,
  canConfigureTicketSeller,
}) {
  const sections = [];
  let step = 1;

  const push = (id, labelKey, hintKey) => {
    sections.push({ id, labelKey, hintKey, step: step++ });
  };

  push("identity", "agentsListPage.formSectionIdentity", "agentsListPage.formSectionIdentityHint");
  push("function", "agentsListPage.formSectionFunction", "agentsListPage.formSectionFunctionHint");

  if (engineType === "n8n") {
    push("n8n", "agentsListPage.formSectionN8n", "agentsListPage.formSectionN8nHint");
  }

  if (engineType === "xpro" && primarySkillKey) {
    push("skill-config", "agentsListPage.formSectionSkillConfig", "agentsListPage.formSectionSkillConfigHint");
  }

  const showKnowledge =
    engineType === "n8n" ||
    (engineType === "xpro" &&
      (primarySkillKey === "faq" ||
        primarySkillKey === "ticket_seller" ||
        primarySkillKey === "social_media"));

  if (showKnowledge) {
    push("knowledge", "agentsListPage.formSectionKnowledge", "agentsListPage.formSectionKnowledgeHint");
  }

  if (engineType === "xpro" && primarySkillKey === "proposal_generator") {
    push("proposal-pdf", "agentsListPage.proposalSectionTitle", "agentsListPage.formSectionProposalHint");
  }

  if (engineType === "xpro" && primarySkillKey === "contract_generator") {
    push("contract-pdf", "agentsListPage.contractSectionTitle", "agentsListPage.formSectionContractHint");
  }

  if (engineType === "xpro") {
    push("ai-settings", "agentsListPage.formSectionAiSettings", "agentsListPage.formSectionAiSettingsHint");
  }

  return sections;
}

export function scrollToAgentFormSection(sectionId) {
  const el = document.getElementById(`agent-form-section-${sectionId}`);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
